/**
 * OKR Routes Component
 *
 * Defines all routes for the OKR module with new hierarchical structure.
 */

import { Routes, Route } from 'react-router-dom';
import {
  Cycles,
  CycleObjectives,
  ObjectiveDetails,
} from '@/features/OKR/pages';
import {
  DashboardRedirect,
  ReportsRedirect,
  ObjectivesRedirect,
  ObjectiveDetailsRedirect,
} from '@/features/OKR/components/RouteRedirects';

export default function OKRRoutes() {
  return (
    <Routes>
      {/* Main OKR Page - Shows Cycles */}
      <Route path="/" element={<Cycles />} />

      {/* Cycle Objectives - Shows objectives within a cycle */}
      <Route path="/cycles/:cycleId" element={<CycleObjectives />} />

      {/* Objective Details - Hierarchical route with cycleId */}
      <Route path="/cycles/:cycleId/objectives/:objectiveId" element={<ObjectiveDetails />} />

      {/* Legacy Route Redirects with Toast Notifications */}
      <Route path="/dashboard" element={<DashboardRedirect />} />
      <Route path="/reports" element={<ReportsRedirect />} />
      <Route path="/objectives" element={<ObjectivesRedirect />} />
      <Route path="/objectives/:objectiveId" element={<ObjectiveDetailsRedirect />} />

      {/* Keep /cycles as alias to root for backward compatibility */}
      <Route path="/cycles" element={<Cycles />} />

      {/* Check-ins - Accessed through objective details page only */}
      {/* <Route path="/check-ins" element={<CheckIns />} /> */}
    </Routes>
  );
}
